// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ViewMembersReport from '../../components/Company/ViewMembersReport/ViewMembersReport';
// Type imports:
import { IAuthenticationWithIdAndEventId } from '../../types/CompanyTypes';

const ViewConstructionsReport: React.FC<IAuthenticationWithIdAndEventId> = ({
    id,
    eventId,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Fyrirtæki'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                noAd
                component={
                    <ViewMembersReport
                        id={id ?? ''}
                        eventId={eventId ?? ''}
                    />
                } 
            />
        </Entrypoint>
    );
}

export default ViewConstructionsReport;